import { createSelector } from "reselect";

import { createRequestFetchingSelector } from "store/requests/selectors";

import { IEntityCollectionState } from "../reducer";

import { ReplyAddressRequestActions } from "./actions";
import { IReplyAddress } from "./interfaces";

export interface IWithReplyAddressesState {
  entities: {
    replyAddresses: {
      entities: IEntityCollectionState<IReplyAddress>;
      loading: boolean;
    };
  };
}

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function selectReplyAddresses(state: IWithReplyAddressesState) {
  return state.entities.replyAddresses.entities;
}

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const selectReplyAddressesAlphabetically = createSelector(selectReplyAddresses, (replyAddresses: any) =>
  // @ts-expect-error TS(18046)
  Object.values(replyAddresses).sort((a, b) => a.email.localeCompare(b.email))
);

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function selectReplyAddress(state: IWithReplyAddressesState, id: string) {
  return selectReplyAddresses(state)[id];
}

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function selectIsReplyAddressLoading(state: IWithReplyAddressesState) {
  return state.entities.replyAddresses.loading;
}

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function selectReplyAddressByPrefixDomainPair(
  state: IWithReplyAddressesState,
  prefix: string,
  emailDomainID: string
) {
  const replyAddresses = selectReplyAddresses(state);
  const targetAddress = Object.values(replyAddresses).find(
    address => address.prefix === prefix && address.emailDomainID === emailDomainID
  );

  return targetAddress;
}

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function selectReplyAddressIsVerified(state: IWithReplyAddressesState, prefix: string, emailDomainID: string) {
  const replyAddress = selectReplyAddressByPrefixDomainPair(state, prefix, emailDomainID);

  return replyAddress && replyAddress.verified;
}

export const selectIsDeletingReplyAddress = createRequestFetchingSelector([
  ReplyAddressRequestActions.DELETE_REPLY_ADDRESS_REQUEST,
]);

export const selectIsCreatingReplyAddress = createRequestFetchingSelector([
  ReplyAddressRequestActions.CREATE_REPLY_ADDRESS_REQUEST,
]);

export const selectIsUpdatingReplyAddress = createRequestFetchingSelector([
  ReplyAddressRequestActions.UPDATE_REPLY_ADDRESS_REQUEST,
]);
